import { render } from "./SelectionDatagridSelectionManufacturerDatagridRow.vue?vue&type=template&id=05e95ca2"
import script from "./SelectionDatagridSelectionManufacturerDatagridRow.vue?vue&type=script&lang=js"
export * from "./SelectionDatagridSelectionManufacturerDatagridRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__